import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import { makeOutfitParser, category, replaceValue } from '../../outfit-parser';

var presetsList = ['primary', 'secondary', 'tertiary', 'quaternary', 'quinary', 'senary'];
var colorsList = ['blue', 'light-blue', 'yellow', 'green', 'orange', 'red', 'white', 'blue-30', 'blue-300', 'monochrome-white'];
var sizesList = ['tiny', 'small', 'normal', 'large', 'x-large'];
var modifiersList = ['hollow', 'expanded', 'groupped', 'pressed'];

export var buttonOutfits = [].concat(presetsList, colorsList, sizesList, modifiersList);

var presetParser = makeOutfitParser(category('presets', presetsList));

var outfitParser = makeOutfitParser(category('colors', colorsList), category('size', sizesList), category('modifiers', modifiersList, true));

var presets = {
  light: {
    primary: 'yellow normal',
    secondary: 'yellow normal hollow',
    tertiary: 'light-blue normal',
    quaternary: 'blue normal',
    quinary: 'blue-30 normal',
    senary: 'monochrome-white normal'
  },
  dark: {
    primary: 'yellow normal',
    secondary: 'yellow normal hollow',
    tertiary: 'light-blue normal',
    quaternary: 'white normal',
    quinary: 'blue-300 normal',
    senary: 'monochrome-white normal'
  }
};

export var parseButtonOutfit = function parseButtonOutfit(outfit, theme) {
  var _presetParser$get = presetParser(outfit).get('presets'),
      _presetParser$get2 = _slicedToArray(_presetParser$get, 1),
      preset = _presetParser$get2[0];

  var value = preset ? replaceValue(outfit, preset, presets[theme][preset]) : outfit;

  return outfitParser(value);
};